import Property from './PropertyRadio';

export default Property.extend({
  defaults: () => ({
    ...Property.prototype.defaults(),
    full: 0
  })
});



// WEBPACK FOOTER //
// webpack://grapesjs/src/style_manager/model/PropertySelect.js